import { foilType, type Card, type Finish } from '@mtg/shared';

/** "Foil", "Etched", or the special foil ("Surge foil", "Galaxy foil"); nothing for non-foil. */
export function FinishBadge({ card, finish }: { card: Pick<Card, 'promoTypes'>; finish: Finish }) {
  const type = foilType(card, finish);
  if (!type) return null;
  return <span className={`badge ${finish}${type.id === finish ? '' : ' special'}`}>{type.label}</span>;
}
